import React, {useEffect, useMemo, useRef} from "react";
import {FilledInput, Input, InputProps, OutlinedInput, TextField} from "@mui/material";
import {MaskedInput} from "@shared/custom/MaskedInput.tsx";
import {OnlyNumeric} from "@shared/MathHelp.ts";

interface CpfCnpjInputProps {
    value?: string;
    onChange?: (value: string) => void;
    onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
    onEnter?: (v?: string) => void;
    slotProps?: {
        TextField?: React.ComponentProps<typeof TextField>
    };
    inputProps?: InputProps;
    label?: string
    cpfDisabled?: boolean
    cnpjDisabled?: boolean
}

export const CpfCnpjInput: React.FC<CpfCnpjInputProps> = (props) => {
    const {value, onChange, onKeyDown, inputProps} = props;

    const masks = {
        Cpf: '000.000.000-00',
        Cnpj: '00.000.000/0000-00',
    };


    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            if (props.onEnter) {
                props.onEnter(value);
            }

        }
        if ((e.key.length == 1 || e.key == 'Backspace') && value && value.length == 14) {
            const newValue = value + e.key;
            if (onChange)
                onChange(newValue);
        }
        if (onKeyDown)
            onKeyDown(e);
    };

    const currentMask = useMemo(() => {
        const {cpfDisabled, cnpjDisabled} = props
        if (!cpfDisabled && cnpjDisabled) {
            return masks.Cpf
        } else if (!cnpjDisabled && cpfDisabled) {
            return masks.Cnpj
        }

        return value && (value.length == 14 || value.length > 0 && value.length < 14) ? masks.Cpf : masks.Cnpj;
    }, [value])

    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    }, [value, currentMask]);

    // Escolhe o componente base conforme o variant do TextField
    const textFieldProps = props.slotProps?.TextField ?? {};
    const variant = textFieldProps.variant ?? 'outlined';
    const BaseInput =
        variant === 'filled' ? FilledInput :
            variant === 'outlined' ? OutlinedInput :
                Input;

    return (
        <TextField
            {...textFieldProps}
            onChange={(e) => {
                if (onChange == null) {
                    e.preventDefault();
                }
                if (onChange)
                    onChange(e.target.value)
            }}
            onKeyDown={(k: React.KeyboardEvent<HTMLInputElement>) => {

                handleKeyDown(k);
            }}
            onPaste={(e) => {
                if (OnlyNumeric(e.clipboardData.getData('text/plain')) && value && value.length < 14) {
                    if (onChange)
                        onChange(value + OnlyNumeric(e.clipboardData.getData('text/plain')));
                }
            }}
            value={value}
            ref={inputRef}
            label={props.label ?? 'Cpf/Cnpj'}
            slots={{
                input: (pseudoprops) => (
                    <BaseInput readOnly={!onChange}
                               inputComponent={(mcProps) => (
                                   <MaskedInput {...mcProps} mask={currentMask} ref={inputRef}/>
                               )}
                               {...pseudoprops}
                               {...inputProps}
                    />
                ),
            }}
        />
    );
};